import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t, i18n } = useTranslation();
  const [showFullText, setShowFullText] = useState(false);

  return (
    <div>
      {/* About Section */}
      <section className={`about-section ${showFullText ? "expanded" : ""}`}>
        <h2>{t("about_us")}</h2>
        {/* Description (Hidden by default on mobile) */}
        <p className={`about-text ${showFullText ? "visible" : "hidden"}`}>
          {t("pub_desc")}
        </p>
        
        {/* Read More Button (Only for Mobile) */}
        <div className="mobile-only">
          <button
            className="read-more-button"
            onClick={() => setShowFullText(!showFullText)}
          >
            {showFullText ? "▲" : "▼"}
          </button>
        </div>
      </section>

      {/* Three Sections in One Row */}
      <div className="info-sections-container">
        {/* Opening Hours Section */}
        <section className="info-section opening-hours-section">
          <h3>
            {t("opening_hours")}
            <span className="opening-hours-icon">
              <i className="fas fa-clock"></i>
            </span>
          </h3>
          <p>{t("thursday_hours")}</p>
        </section>

        {/* Location Section */}
        <section className="info-section location-section">
          <h3>
            {i18n.language === "he" ? "?איפה" : "Where?"}
            <span className="location-icon">
              <i className="fas fa-map-marker-alt"></i>
            </span>
          </h3>
          <p>
            <a
              href="https://ul.waze.com/ul?place=ChIJ_z9g09eGAhUR_AFbv7XLiqo&ll=31.48557330%2C34.60552640&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location"
              target="_blank"
              rel="noopener noreferrer"
              className="location-link"
            >
              {i18n.language === "he"
                ? "כפר הסטודנטים של איילים ביכיני"
                : "Ayalim Student Village in Yahini (כפר הסטודנטים של איילים ביכיני)"}
            </a>
          </p>
        </section>

        {/* Contact Section */}
        <section className="info-section contact-section">
          <h3>{t("make_contact")}</h3>
          <p>
            <i className="fas fa-phone"></i>{" "}
            <a href="tel:+972507568256" className="contact-link">050-7568256</a>
          </p>
          <p>
            <i className="fas fa-phone"></i>{" "}
            <a href="tel:+972544365432" className="contact-link">054-4365432</a>
          </p>
          <p>
            <i className="fab fa-instagram"></i>{" "}
            <a
              href="https://www.instagram.com/barkatze.1/"
              target="_blank"
              rel="noopener noreferrer"
              className="contact-link"
            >
              {t("instagram")}
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Home;
